import get_standardised_date from "./get_standardised_date";

function getTimestamp(date){
    date = new Date(get_standardised_date(date));
    return date.getTime();
}

export default getTimestamp;